import actions from './actions';

const jurisReducer = (state = {
    resultados: undefined
}, action: { type: any; payload: any; }) => {
    switch (action.type) {
        case actions.SET_RESULTS:
            return Object.assign({}, state, {
                resultados: action.payload
            })
        case actions.RESET_RESULTS:
            return Object.assign({}, state, {
                resultados: undefined
            })
        default:
            return state;
    }
}

export default jurisReducer;